'use strict';

const COOKIE_MAX_AGE = 400 * 24 * 60 * 60; // browsers cap first-party cookies at ~400 days

function rootDomain() {
  const host = window.location.hostname;
  if (/^[\d.]+$/.test(host) || host === 'localhost') return host;
  const parts = host.split('.');
  return parts.length > 2 ? `.${parts.slice(-2).join('.')}` : `.${host}`;
}

function setCookie(name, value, maxAge = COOKIE_MAX_AGE) {
  try {
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(value)}; Max-Age=${maxAge}; Path=/; Domain=${rootDomain()}; SameSite=Lax${secure}`;
  } catch (_) { /* cookies disabled */ }
}

function getCookie(name) {
  try {
    const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : null;
  } catch (_) { return null; }
}

function lsGet(key) {
  try { return window.localStorage.getItem(key); } catch (_) { return null; }
}

function lsSet(key, value) {
  try { window.localStorage.setItem(key, value); return true; } catch (_) { return false; }
}

function lsRemove(key) {
  try { window.localStorage.removeItem(key); } catch (_) { /* noop */ }
}

function ssGet(key) {
  try { return window.sessionStorage.getItem(key); } catch (_) { return null; }
}

function ssSet(key, value) {
  try { window.sessionStorage.setItem(key, value); return true; } catch (_) { return false; }
}

/**
 * Reads through cookie -> localStorage so the visitor id survives either one
 * being cleared, then writes the surviving value back to both.
 */
function durableGet(key) {
  const fromCookie = getCookie(key);
  const fromLocal = lsGet(key);
  const value = fromCookie || fromLocal;
  if (value) {
    if (!fromCookie) setCookie(key, value);
    if (!fromLocal) lsSet(key, value);
  }
  return value;
}

function durableSet(key, value) {
  setCookie(key, value);
  lsSet(key, value);
}

function jsonGet(key) {
  const raw = lsGet(key);
  if (!raw) return null;
  try { return JSON.parse(raw); } catch (_) { return null; }
}

const jsonSet = (key, value) => lsSet(key, JSON.stringify(value));

module.exports = {
  setCookie, getCookie, lsGet, lsSet, lsRemove, ssGet, ssSet,
  durableGet, durableSet, jsonGet, jsonSet, rootDomain,
};
